"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = exports.formatTimeToRelative = exports.getSessionToken = exports.setSessionToken = exports.removeRefreshToken = exports.getRefreshToken = exports.getIsUserLogged = exports.setIsUserLogged = exports.saveRefreshToken = exports.removeToken = exports.getToken = exports.saveToken = exports.setCookie = exports.calculateWidgetPosition = exports.getPanelSize = exports.isSizeChangable = exports.getPartSize = exports.convertWeightToSI = exports.getDoubleAnchorGroupFastenerSizeInInches = exports.convertToSI = exports.getLabelInInch = exports.getLabelInMM = exports.getScreenShots = exports.blobToBase64 = exports.animate = exports.isNumber = exports.uuidv4 = exports.formatAddressForDropdown = exports.formatCustomerForDropdown = exports.formatDistributorForDropdown = exports.validatePhoneNumber = exports.generateUniqueLikeString = exports.stringToRgb = exports.hexToRgb = exports.isICatalogItem = exports.getItemColor = exports.getItemProperty = exports.getItemPropertyDetails = exports.roundWithoutTrailingZeros = exports.normalizeValueToStep = exports.floorToDecimals = exports.roundToDecimals = exports.last = exports.formatSize = exports.formatCurrencyLetters = exports.formatCurrency = exports.formatDateForDateInput = exports.formatAssetsURL = exports.formatAPIURL = exports.errorify = void 0;
exports.dateToShortFormat = exports.formatDateinUSAFormat = exports.isDiscountValid = exports.replaceProjectItemsOnScene = exports.setProjectOnScene = exports.resetScene = exports.isEventTargetOverflowing = void 0;
const events_1 = require("~/utils/events");
const consts_1 = require("~/components/Cad3d/consts");
const consts_2 = require("~/consts/consts");
const types_1 = require("~/store/types");
const Viewer_1 = __importDefault(require("~/components/Cad3d/Viewer"));
const events_2 = require("~/consts/events");
const roundNumberWithDecimals_1 = __importDefault(require("./roundNumberWithDecimals"));
const CURRENT_ENV = String(process.env.AWS_3_ROOT);
const NEGATIVE_Z = '-Z';
const POZITIVE_XY = 'XY';
const errorify = (error) => {
    if (error instanceof Error) {
        return String(error);
    }
    return String(Error((error === null || error === void 0 ? void 0 : error.toString()) || 'An unknown error occurred'));
};
exports.errorify = errorify;
const formatAPIURL = (url) => {
    return `${process.env.API_HOSTNAME}${url}`;
};
exports.formatAPIURL = formatAPIURL;
const formatAssetsURL = (url) => {
    const relativePath = (url === null || url === void 0 ? void 0 : url.startsWith(`/${process.env.AWS_3_ROOT}`)) ? '' : `/${process.env.AWS_3_ROOT}`;
    const assetUrl = `${process.env.ASSETS_HOST}${relativePath}${url}${window.loadingTime ? `?t=${window.loadingTime}` : ``}`;
    if (!url) {
        return `${process.env.ASSETS_HOST}/${CURRENT_ENV}${consts_2.itemPlaceholderSrc}`;
    }
    return assetUrl;
};
exports.formatAssetsURL = formatAssetsURL;
const formatDateForDateInput = (date) => {
    if (!date || Number.isNaN(date.getTime())) {
        return '';
    }
    const year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
    const month = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date);
    const day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
    return `${year}-${month}-${day}`;
};
exports.formatDateForDateInput = formatDateForDateInput;
const formatCurrency = (value, precision = 3) => {
    return `$${(0, roundNumberWithDecimals_1.default)(Number(value), precision).toFixed(precision)}`;
};
exports.formatCurrency = formatCurrency;
const formatCurrencyLetters = (value, precision = 3, currency = 'USD') => {
    return `${(0, roundNumberWithDecimals_1.default)(Number(value), precision)} ${currency}`;
};
exports.formatCurrencyLetters = formatCurrencyLetters;
const formatSize = (value) => {
    return `${value.toFixed(3)} in`;
};
exports.formatSize = formatSize;
const last = (array) => [].concat(array).pop();
exports.last = last;
const roundToDecimals = (number, precision) => Math.round(number * Math.pow(10, precision)) / Math.pow(10, precision);
exports.roundToDecimals = roundToDecimals;
const floorToDecimals = (number, precision) => Math.floor((number + Number.EPSILON) * Math.pow(10, precision)) / Math.pow(10, precision);
exports.floorToDecimals = floorToDecimals;
const normalizeValueToStep = (number, step, precision) => (Math.floor(((0, exports.floorToDecimals)(number, precision) * Math.pow(10, precision)) / (step * Math.pow(10, precision))) *
    (step * Math.pow(10, precision))) /
    Math.pow(10, precision);
exports.normalizeValueToStep = normalizeValueToStep;
const roundWithoutTrailingZeros = (value, precision) => {
    const roundedValue = value.toFixed(precision);
    return roundedValue.replace(/\.?0*$/, '');
};
exports.roundWithoutTrailingZeros = roundWithoutTrailingZeros;
const getItemPropertyDetails = (item, property) => {
    var _a, _b;
    return (_b = (_a = item.itemProperties) === null || _a === void 0 ? void 0 : _a.find((prop) => { var _a; return ((_a = prop.property) === null || _a === void 0 ? void 0 : _a.name) === property; })) !== null && _b !== void 0 ? _b : null;
};
exports.getItemPropertyDetails = getItemPropertyDetails;
const getItemProperty = (item, property) => {
    const res = (0, exports.getItemPropertyDetails)(item, property);
    return (res === null || res === void 0 ? void 0 : res.value) || null;
};
exports.getItemProperty = getItemProperty;
const getItemColor = (item) => {
    var _a;
    return (_a = item.color) === null || _a === void 0 ? void 0 : _a.rgb_value;
};
exports.getItemColor = getItemColor;
const isICatalogItem = (obj) => {
    return 'itemType' in obj;
};
exports.isICatalogItem = isICatalogItem;
const hexToRgb = (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? ({
            r: Number.parseInt(result[1], 16),
            g: Number.parseInt(result[2], 16),
            b: Number.parseInt(result[3], 16),
        })
        : null;
};
exports.hexToRgb = hexToRgb;
const stringToRgb = (hex) => {
    const result = /^#?(\d{1,2}),(\d{1,2}),(\d{1,2})$/i.exec(hex);
    return result
        ? ({
            r: Number.parseInt(result[1], 10),
            g: Number.parseInt(result[2], 10),
            b: Number.parseInt(result[3], 10),
        })
        : null;
};
exports.stringToRgb = stringToRgb;
const generateUniqueLikeString = () => crypto.randomUUID().replace(/-/g, '').substring(0, 7);
exports.generateUniqueLikeString = generateUniqueLikeString;
const validatePhoneNumber = (value) => {
    return /^\d{8,15}$/g.test(value);
};
exports.validatePhoneNumber = validatePhoneNumber;
const formatDistributorForDropdown = (distributor) => {
    var _a;
    if (!distributor) {
        return null;
    }
    const res = [
        distributor.companyName,
        distributor.publicAddress.addressLine,
        distributor.publicAddress.city,
        distributor.publicAddress.state,
        distributor.publicAddress.zip,
        (_a = distributor.publicAddress.country) === null || _a === void 0 ? void 0 : _a.name,
    ];
    return res.filter(Boolean).join(', ');
};
exports.formatDistributorForDropdown = formatDistributorForDropdown;
const formatCustomerForDropdown = (customer) => {
    if (!customer) {
        return null;
    }
    return `${customer.firstName} ${customer.lastName}${customer.companyName ? `, ${customer.companyName}` : ''}`.trimEnd();
};
exports.formatCustomerForDropdown = formatCustomerForDropdown;
const formatAddressForDropdown = (address) => {
    var _a;
    if (!address) {
        return '';
    }
    const res = [
        address.addressLine,
        address.addressLine2,
        address.city,
        address.state,
        address.zip,
        (_a = address.country) === null || _a === void 0 ? void 0 : _a.name,
    ];
    return res.filter(Boolean).join(', ');
};
exports.formatAddressForDropdown = formatAddressForDropdown;
const uuidv4 = () => {
    return crypto.randomUUID().toLocaleUpperCase();
};
exports.uuidv4 = uuidv4;
// Returns <True> if @value is numeric and <False> otherwise
const isNumber = (value) => {
    // eslint-disable-next-line no-restricted-globals
    return value !== null && value !== '' && !Number.isNaN(Number(value.toString()));
};
exports.isNumber = isNumber;
function animate({ timing, draw, duration, afterEnd, }) {
    const start = performance.now();
    requestAnimationFrame(function animationFunc(time) {
        let timeFraction = (time - start) / duration;
        if (timeFraction > 1) {
            timeFraction = 1;
        }
        const progress = timing(timeFraction);
        draw(progress);
        if (timeFraction < 1) {
            requestAnimationFrame(animationFunc);
        }
        else if (afterEnd) {
            afterEnd();
        }
    });
}
exports.animate = animate;
const blobToBase64 = (blob) => {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => { var _a, _b; return resolve((_b = (_a = reader.result) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : ''); };
        reader.readAsDataURL(blob);
    });
};
exports.blobToBase64 = blobToBase64;
const getScreenShots = (explosionCoefficient, customizationOptions = {
    isometricView: true,
    explodedExtrusions: true,
    explodedComponents: true,
    projectDimensions: true,
    panels: true,
}) => {
    return new Promise((resolve) => {
        const handler = (event) => __awaiter(void 0, void 0, void 0, function* () {
            const blobScreenshots = event.detail;
            const frontImagePromise = blobScreenshots.front ? (0, exports.blobToBase64)(blobScreenshots.front) : Promise.resolve('');
            const isometricImagePromise = blobScreenshots.isometric
                ? (0, exports.blobToBase64)(blobScreenshots.isometric)
                : Promise.resolve('');
            const isometricImageWithBalloonsPromise = (customizationOptions === null || customizationOptions === void 0 ? void 0 : customizationOptions.isometricView) && blobScreenshots.isometricWithBalloons
                ? (0, exports.blobToBase64)(blobScreenshots.isometricWithBalloons)
                : Promise.resolve(null);
            const explodedImageWithExtrusionsBalloonsPromise = (customizationOptions === null || customizationOptions === void 0 ? void 0 : customizationOptions.explodedExtrusions) && blobScreenshots.explodedWithBalloonsForExtrusions
                ? (0, exports.blobToBase64)(blobScreenshots.explodedWithBalloonsForExtrusions)
                : Promise.resolve(null);
            const explodedImageWithComponentsBalloonsPromise = (customizationOptions === null || customizationOptions === void 0 ? void 0 : customizationOptions.explodedComponents) && blobScreenshots.explodedWithBalloonsForComponents
                ? (0, exports.blobToBase64)(blobScreenshots.explodedWithBalloonsForComponents)
                : Promise.resolve(null);
            let panelImagesResult = [];
            if ((customizationOptions === null || customizationOptions === void 0 ? void 0 : customizationOptions.panels) && blobScreenshots.panels && blobScreenshots.panels.length > 0) {
                const panelPromises = blobScreenshots.panels.map((panelScreenShot) => __awaiter(void 0, void 0, void 0, function* () {
                    const imageBase64 = yield (0, exports.blobToBase64)(panelScreenShot.blob);
                    return {
                        id: panelScreenShot.id,
                        description: panelScreenShot.description,
                        image: imageBase64,
                        quantity: panelScreenShot.quantity,
                        orderNumber: panelScreenShot.orderNumber,
                    };
                }));
                panelImagesResult = yield Promise.all(panelPromises);
            }
            let projectDimensionsImagesResult = [];
            if ((customizationOptions === null || customizationOptions === void 0 ? void 0 : customizationOptions.projectDimensions) && blobScreenshots.projectDimensions) {
                const dimensionPromises = Object.entries(blobScreenshots.projectDimensions).map(([projectView, imageBlob]) => __awaiter(void 0, void 0, void 0, function* () {
                    const imageBase64 = yield (0, exports.blobToBase64)(imageBlob);
                    return {
                        view: projectView,
                        image: imageBase64,
                    };
                }));
                projectDimensionsImagesResult = yield Promise.all(dimensionPromises);
            }
            const frontImage = yield frontImagePromise;
            const isometricImage = yield isometricImagePromise;
            const isometricWithBalloonsImage = yield isometricImageWithBalloonsPromise;
            const explodedWithExtrusionsBalloonsImage = yield explodedImageWithExtrusionsBalloonsPromise;
            const explodedWithComponentsBalloonsImage = yield explodedImageWithComponentsBalloonsPromise;
            document.body.removeEventListener(events_2.responseScreenshots, handler);
            return resolve({
                frontImage,
                isometricImage,
                isometricWithBalloonsImage,
                explodedWithExtrusionsBalloonsImage,
                explodedWithComponentsBalloonsImage,
                panelImages: panelImagesResult.length > 0 ? panelImagesResult : null,
                projectDimensionsImages: projectDimensionsImagesResult,
            });
        });
        document.body.addEventListener(events_2.responseScreenshots, handler);
        document.body.dispatchEvent((0, events_1.requestScreenshotsEvent)(explosionCoefficient));
    });
};
exports.getScreenShots = getScreenShots;
function getLabelInMM(inches, appendZeroes = false) {
    const roundedValue = (0, exports.roundToDecimals)(inches * consts_1.consts.INCH_TO_MM, consts_2.PRECISION_IN_LABELS);
    const finalValue = appendZeroes ? roundedValue.toFixed(consts_2.PRECISION_IN_LABELS) : roundedValue;
    return `${finalValue} mm`;
}
exports.getLabelInMM = getLabelInMM;
function getLabelInInch(inches, appendZeroes = false) {
    let a = (0, exports.roundToDecimals)(inches, consts_2.PRECISION_IN_LABELS).toFixed(consts_2.PRECISION_IN_LABELS);
    if (a.at(-1) === '0' && !appendZeroes) {
        a = a.slice(0, -1);
    }
    return `${a}"`;
}
exports.getLabelInInch = getLabelInInch;
function convertToSI({ size, price, unitOfMeasurement }) {
    switch (unitOfMeasurement) {
        case 'SQ FT':
            return {
                unitOfMeasurement: 'SQ M',
                price: (price !== null && price !== void 0 ? price : 0) * consts_1.consts.SQ_M_TO_SQ_FT,
                size: (size !== null && size !== void 0 ? size : 0) / consts_1.consts.SQ_M_TO_SQ_FT,
            };
        case 'FT':
            return {
                unitOfMeasurement: 'M',
                price: (price !== null && price !== void 0 ? price : 0) * consts_1.consts.M_TO_FT,
                size: (size !== null && size !== void 0 ? size : 0) / consts_1.consts.M_TO_FT,
            };
        case 'IN':
            return {
                unitOfMeasurement: 'MM',
                price: (price !== null && price !== void 0 ? price : 0) / consts_1.consts.INCH_TO_MM,
                size: (size !== null && size !== void 0 ? size : 0) * consts_1.consts.INCH_TO_MM,
            };
        default:
            return { unitOfMeasurement, price, size };
    }
}
exports.convertToSI = convertToSI;
function getDoubleAnchorGroupFastenerSizeInInches(item) {
    var _a;
    const sizeProperty = (_a = item.itemProperties) === null || _a === void 0 ? void 0 : _a.find((property) => property.property.name === types_1.ITEM_PROPERTY_NAMES.SIZE);
    if (!sizeProperty || !sizeProperty.measurementUnit) {
        return undefined;
    }
    const isSizeInInches = sizeProperty.measurementUnit.name === types_1.MEASUREMENT_UNIT.IMPERIAL;
    const size = Number.parseFloat(sizeProperty.value);
    return isSizeInInches ? size : size * consts_1.consts.MM_TO_INCH;
}
exports.getDoubleAnchorGroupFastenerSizeInInches = getDoubleAnchorGroupFastenerSizeInInches;
function convertWeightToSI(weight) {
    return weight * consts_1.consts.LBS_TO_KG;
}
exports.convertWeightToSI = convertWeightToSI;
const getPartSize = (item) => {
    if (item.is_scalable && item.scale_axes === NEGATIVE_Z) {
        return item.itemType.name === 'Component' ? 1 : Number((0, exports.getItemProperty)(item, 'Stock length'));
    }
    return 1;
};
exports.getPartSize = getPartSize;
const isSizeChangable = (item) => {
    return item.isScalable && item.scaleAxes === NEGATIVE_Z && item.type !== 'Component';
};
exports.isSizeChangable = isSizeChangable;
const getPanelSize = (item) => {
    if (item.is_scalable && item.scale_axes === POZITIVE_XY) {
        return {
            x: Number((0, exports.getItemProperty)(item, 'Stock width')),
            y: Number((0, exports.getItemProperty)(item, 'Stock length')),
        };
    }
    return undefined;
};
exports.getPanelSize = getPanelSize;
const calculateWidgetPosition = (x, y, widgetHeight, widgetWidth, windowHeight) => {
    const gap = 16;
    const xDistance = 64;
    const yDistance = 153;
    const xPadding = 16;
    const yPadding = 72;
    const upPoint = { x: x - xPadding, y: y - yPadding };
    upPoint.x = upPoint.x - xDistance - widgetWidth;
    if (upPoint.x < 0) {
        upPoint.x = upPoint.x + 2 * xDistance + widgetWidth;
    }
    upPoint.y -= yDistance;
    const downPoint = {
        x: upPoint.x + widgetWidth,
        y: upPoint.y + widgetHeight,
    };
    if (upPoint.y >= yPadding) {
        if (downPoint.y > windowHeight - yPadding) {
            upPoint.y = windowHeight - widgetHeight - gap - yPadding;
        }
    }
    else {
        upPoint.y = gap;
    }
    return upPoint;
};
exports.calculateWidgetPosition = calculateWidgetPosition;
const setCookie = ({ name, value, days }) => {
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value || ''}${expires}; path=/`;
};
exports.setCookie = setCookie;
const saveToken = (token) => {
    localStorage.setItem('token', token);
    (0, exports.setCookie)({ name: 'token', value: token, days: 7 });
};
exports.saveToken = saveToken;
const getToken = () => localStorage.getItem('token');
exports.getToken = getToken;
const removeToken = () => {
    localStorage.removeItem('token');
    (0, exports.setCookie)({ name: 'token', value: '', days: 0 });
};
exports.removeToken = removeToken;
const saveRefreshToken = (token) => {
    localStorage.setItem('refresh_token', token);
};
exports.saveRefreshToken = saveRefreshToken;
const setIsUserLogged = (isUserLogged) => {
    localStorage.setItem('isUserLogged', String(isUserLogged));
};
exports.setIsUserLogged = setIsUserLogged;
const getIsUserLogged = () => localStorage.getItem('isUserLogged') === 'true';
exports.getIsUserLogged = getIsUserLogged;
const getRefreshToken = () => localStorage.getItem('refresh_token');
exports.getRefreshToken = getRefreshToken;
const removeRefreshToken = () => localStorage.removeItem('refresh_token');
exports.removeRefreshToken = removeRefreshToken;
const setSessionToken = (sessionToken) => {
    document.cookie = `session_token=${sessionToken};Max-Age=604800;SameSite=Strict`;
};
exports.setSessionToken = setSessionToken;
const getSessionToken = () => {
    const cookie = `; ${document.cookie}`;
    const parts = cookie.split(`; session_token=`);
    if (!parts) {
        return '';
    }
    return parts.length === 2 ? parts.pop().split(';').shift() : '';
};
exports.getSessionToken = getSessionToken;
const formatTimeToRelative = (time) => {
    if (!time) {
        return '-';
    }
    const period = Date.now() - Date.parse(time);
    const days = Math.floor(period / 86400000);
    if (days > 0) {
        return `${days} ${days > 1 ? 'days' : 'day'} ago`;
    }
    const hours = Math.floor(period / 3600000);
    if (hours > 0) {
        return `${hours} ${hours > 1 ? 'hours' : 'hour'} ago`;
    }
    const minutes = Math.floor(period / 60000) || 1;
    if (minutes > 1) {
        return `${minutes} minutes ago`;
    }
    return '1 minute ago';
};
exports.formatTimeToRelative = formatTimeToRelative;
const debounce = (ms, fn, immediately = false) => {
    let timer;
    return function (...args) {
        if (timer === undefined && immediately) {
            fn.apply(this, args);
        }
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), ms);
        return timer;
    };
};
exports.debounce = debounce;
const isEventTargetOverflowing = (e) => {
    const htmlElement = e.target;
    return htmlElement.offsetWidth < htmlElement.scrollWidth;
};
exports.isEventTargetOverflowing = isEventTargetOverflowing;
const resetScene = () => {
    document.body.dispatchEvent(events_1.refreshSceneEvent);
};
exports.resetScene = resetScene;
const setProjectOnScene = (projectItems) => __awaiter(void 0, void 0, void 0, function* () {
    yield Viewer_1.default.instance.setProjectOnScene(projectItems);
});
exports.setProjectOnScene = setProjectOnScene;
const replaceProjectItemsOnScene = (replacementData) => __awaiter(void 0, void 0, void 0, function* () {
    yield Viewer_1.default.instance.replaceProjectItemsOnScene(replacementData);
});
exports.replaceProjectItemsOnScene = replaceProjectItemsOnScene;
const isDiscountValid = (discountTypes, discount) => {
    if (!discount || !discountTypes.includes(discount === null || discount === void 0 ? void 0 : discount.discountType.name)) {
        return false;
    }
    const currentDate = new Date().setHours(0, 0, 0, 0);
    const discountStartDate = new Date(discount.startDate).setHours(0, 0, 0, 0);
    const discountExpirationDate = discount.expirationDate && new Date(discount.expirationDate).setHours(0, 0, 0, 0);
    return discountStartDate <= currentDate && (!discountExpirationDate || currentDate <= discountExpirationDate);
};
exports.isDiscountValid = isDiscountValid;
const formatDateinUSAFormat = (ISODate) => {
    const currentDate = new Date(ISODate);
    const DATE_PREFIX = 0;
    const month = currentDate.getMonth() + 1;
    const monthWithPrefix = month < 10 ? `${DATE_PREFIX}${month}` : month;
    const day = currentDate.getDate();
    const dayWithPrefix = day < 10 ? `${DATE_PREFIX}${day}` : day;
    const year = currentDate.getFullYear();
    return `${monthWithPrefix}/${dayWithPrefix}/${year}`;
};
exports.formatDateinUSAFormat = formatDateinUSAFormat;
const dateToShortFormat = (date) => {
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
};
exports.dateToShortFormat = dateToShortFormat;
